// removed by extract-text-webpack-plugin
module.exports = {"listMenu":"y4rPXRoBo2nuSXnzQUUUH","listMenuTypeRaised":"_3bFokZ-Nkrc8eNUpZPC0X_"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-gui/src/modules/02-organisms/lists/list.scss
// module id = 124
// module chunks = 0